var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1871 27.1869L14.8127 14.8125M27.1871 14.8125L14.8127 27.1869",
    stroke: "#662929",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62563 33.3744C1.79146 26.5402 1.79146 15.4598 8.62563 8.62563C15.4598 1.79146 26.5402 1.79146 33.3744 8.62563C40.2085 15.4598 40.2085 26.5402 33.3744 33.3744C26.5402 40.2086 15.4598 40.2086 8.62563 33.3744Z",
    fill: "#FAE5DA",
    stroke: "#D5C2BA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1874 27.1869L14.813 14.8125M27.1874 14.8125L14.813 27.1869",
    stroke: "#A48D85",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modalClose.c63ad452883ec82fba7da8f959eff842.svg";
export { ForwardRef as ReactComponent };